// extracted by mini-css-extract-plugin
module.exports = {"stat-nav-bg":"StatNavBar_stat-nav-bg__3s6rO","stat-nav-btn":"StatNavBar_stat-nav-btn__3HwU3"};